import { get } from "lodash"

export const getSharedLink = state => get(state, "modules.shareMyView.sharedLink")
export const getCreatedSharedLinks = state => get(state, "modules.shareMyView.createdSharedLinks")
